/* ============================================================
   STRIP CLUB® — theme.js
   Vanilla, dependency-free behaviour for the OS 2.0 theme.
   Wired entirely through data-* attributes so sections stay declarative.
   ============================================================ */
(function () {
  "use strict";

  var money = window.SCTheme && window.SCTheme.moneyFormat ? window.SCTheme.moneyFormat : "${{amount}}";

  function formatMoney(cents) {
    // Minimal Shopify money formatter (amount / amount_with_comma_separator).
    var value = (cents / 100);
    function withDelimiters(num, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ",";
      decimal = decimal || ".";
      var parts = num.toFixed(precision).split(".");
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : "");
    }
    return money.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case "amount": return withDelimiters(value, 2, ",", ".");
        case "amount_no_decimals": return withDelimiters(value, 0, ",", ".");
        case "amount_with_comma_separator": return withDelimiters(value, 2, ".", ",");
        case "amount_no_decimals_with_comma_separator": return withDelimiters(value, 0, ".", ",");
        default: return withDelimiters(value, 2, ",", ".");
      }
    }).replace(/([.,])00$/, ""); // whole prices show bare (€29), cents keep (€23,20)
  }
  window.SCFormatMoney = formatMoney;

  /* ---------- video autoplay — deferred until visible so the multi-MB file
     doesn't download during initial page load and delay the hero (LCP) ---------- */
  function initVideos() {
    var vids = document.querySelectorAll("[data-sc-video]");
    if (!vids.length) return;
    function start(v) {
      v.muted = true;
      v.loop = true;
      v.setAttribute("playsinline", "");
      var p = v.play();
      if (p && p.catch) p.catch(function () {
        // Autoplay refused (iOS Low Power Mode, data saver): pull in the first
        // frame as a still so the panel isn't blank, and retry on first touch —
        // a user gesture may start playback even when autoplay is blocked.
        if (v.getAttribute("preload") === "none") {
          v.setAttribute("preload", "metadata");
          try { v.load(); } catch (err) {}
        }
        if (v.dataset.scKick) return;
        v.dataset.scKick = "1";
        var kick = function () {
          var pp = v.play();
          if (pp && pp.catch) pp.catch(function () {});
        };
        document.addEventListener("touchend", kick, { once: true });
        document.addEventListener("click", kick, { once: true });
      });
    }
    if (!("IntersectionObserver" in window)) {
      vids.forEach(start);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) start(e.target);
        else if (!e.target.paused) e.target.pause();
      });
    }, { rootMargin: "200px 0px" });
    vids.forEach(function (v) { io.observe(v); });
  }

  /* ---------- accordions ---------- */
  function initAccordions() {
    document.querySelectorAll("[data-sc-accordion]").forEach(function (group) {
      group.addEventListener("click", function (e) {
        var btn = e.target.closest("[data-sc-acc-btn]");
        if (!btn || !group.contains(btn)) return;
        var panel = document.getElementById(btn.getAttribute("aria-controls"));
        var isOpen = btn.getAttribute("aria-expanded") === "true";
        // collapse siblings
        group.querySelectorAll("[data-sc-acc-btn]").forEach(function (b) {
          b.setAttribute("aria-expanded", "false");
          var sign = b.querySelector("[data-sc-acc-sign]");
          if (sign) sign.textContent = "+";
          var pnl = document.getElementById(b.getAttribute("aria-controls"));
          if (pnl) pnl.hidden = true;
        });
        if (!isOpen) {
          btn.setAttribute("aria-expanded", "true");
          var sign2 = btn.querySelector("[data-sc-acc-sign]");
          if (sign2) sign2.textContent = "−";
          if (panel) panel.hidden = false;
        }
      });
    });
  }

  /* ---------- login / signup toggle ---------- */
  function initLoginToggle() {
    document.querySelectorAll("[data-sc-login]").forEach(function (root) {
      var tabs = root.querySelectorAll("[data-sc-login-tab]");
      var views = root.querySelectorAll("[data-sc-login-view]");
      tabs.forEach(function (tab) {
        tab.addEventListener("click", function () {
          var mode = tab.getAttribute("data-sc-login-tab");
          tabs.forEach(function (t) { t.setAttribute("aria-selected", String(t === tab)); });
          views.forEach(function (v) { v.hidden = v.getAttribute("data-sc-login-view") !== mode; });
        });
      });
    });
  }

  /* ---------- PDP gallery ---------- */
  function initGallery() {
    document.querySelectorAll("[data-sc-gallery]").forEach(function (gallery) {
      var slides = gallery.querySelectorAll(".sc-gallery__slide");
      if (slides.length < 2) return;
      var thumbs = gallery.querySelectorAll(".sc-thumb[data-sc-slide], .sc-gdot[data-sc-slide]");
      function activate(idx) {
        slides.forEach(function (s) {
          var on = s.getAttribute("data-sc-slide") === idx;
          s.classList.toggle("is-active", on);
          var v = s.querySelector("video");
          if (on) {
            // Autoplay the active slide's video (muted so it's allowed inline)
            if (v) { try { v.muted = true; var pr = v.play(); if (pr && pr.catch) { pr.catch(function () {}); } } catch (e) {} }
          } else {
            if (v) { try { v.pause(); } catch (e) {} }
            // Reset external-video iframes so hidden ones stop playing
            var f = s.querySelector("iframe");
            if (f) { f.src = f.src; }
          }
        });
        thumbs.forEach(function (t) {
          var on = t.getAttribute("data-sc-slide") === idx;
          t.classList.toggle("is-active", on);
          t.setAttribute("aria-current", String(on));
        });
      }
      // Optional auto-advance (data-sc-autoplay = ms per photo). Videos play to the end
      // before moving on; it pauses off-screen / in a hidden tab and stops for good
      // once the shopper taps a thumbnail themselves.
      var delay = parseInt(gallery.getAttribute("data-sc-autoplay"), 10);
      var timer = null, stopped = false, visible = true, cur = 0;
      function current() { return slides[cur]; }
      function schedule() {
        clearTimeout(timer);
        if (stopped || !visible || document.hidden) return;
        var v = current().querySelector("video");
        var dot = gallery.querySelector('.sc-gdot[data-sc-slide="' + current().getAttribute("data-sc-slide") + '"]');
        if (dot) {
          dot.style.setProperty("--sc-gal-dur", v && v.duration ? v.duration + "s" : (current().querySelector("iframe") ? Math.max(delay, 12000) : delay) / 1000 + "s");
          // restart the fill so it matches the timer (e.g. after scrolling back into view)
          dot.classList.remove("is-active"); void dot.offsetWidth; dot.classList.add("is-active");
        }
        if (v) {
          // wait for the clip to finish (cap at 30s in case metadata never loads)
          timer = setTimeout(next, 30000);
          return;
        }
        if (current().querySelector("iframe")) { timer = setTimeout(next, Math.max(delay, 12000)); return; }
        timer = setTimeout(next, delay);
      }
      function next() {
        cur = (cur + 1) % slides.length;
        activate(slides[cur].getAttribute("data-sc-slide"));
        schedule();
      }
      function goManual(i) {
        stopped = true; clearTimeout(timer); gallery.classList.add("is-manual");
        cur = (i + slides.length) % slides.length;
        activate(slides[cur].getAttribute("data-sc-slide"));
      }
      thumbs.forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          var i = 0; slides.forEach(function (s, k) { if (s.getAttribute("data-sc-slide") === thumb.getAttribute("data-sc-slide")) i = k; });
          goManual(i);
        });
      });
      // Arrows on the photo + swipe on phones (dots navigation)
      gallery.querySelectorAll("[data-sc-gal-step]").forEach(function (btn) {
        btn.addEventListener("click", function () { goManual(cur + parseInt(btn.getAttribute("data-sc-gal-step"), 10)); });
      });
      var frame = gallery.querySelector(".sc-gallery__frame"), sx = null, sy = null;
      if (frame && gallery.querySelector(".sc-gdot")) {
        frame.addEventListener("touchstart", function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
        frame.addEventListener("touchend", function (e) {
          if (sx === null) return;
          var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy; sx = null;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) goManual(cur + (dx < 0 ? 1 : -1));
        }, { passive: true });
      }
      if (delay > 0 && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        slides.forEach(function (s, i) {
          var v = s.querySelector("video");
          if (!v) return;
          v.loop = false;
          v.addEventListener("ended", function () {
            if (!stopped && i === cur) { next(); } else { try { v.currentTime = 0; v.play(); } catch (e) {} }
          });
        });
        if ("IntersectionObserver" in window) {
          new IntersectionObserver(function (es) {
            visible = es[0].isIntersecting;
            if (visible) { schedule(); } else { clearTimeout(timer); }
          }, { threshold: 0.3 }).observe(gallery);
        }
        document.addEventListener("visibilitychange", function () { if (document.hidden) { clearTimeout(timer); } else { schedule(); } });
        schedule();
      }
    });
  }

  /* ---------- PDP purchase form (plans + qty + AJAX add) ---------- */
  function initProductForm() {
    document.querySelectorAll("[data-sc-product-form]").forEach(function (form) {
      var planInput = form.querySelector("[data-sc-selling-plan]");
      var priceEl = form.querySelector("[data-sc-price]");
      var ctaLabel = form.querySelector("[data-sc-cta-label]");
      var ctaTotal = form.querySelector("[data-sc-cta-total]");
      var qtyInput = form.querySelector("[data-sc-qty-input]");
      var qtyWrap = form.querySelector(".sc-qty");
      var plans = form.querySelectorAll("[data-sc-plan]");
      var state = { plan: null, unit: 0, recurring: false, qty: 1 };
      // Multi-buy deal (e.g. 2 for €49): box picker + discounted CTA total.
      // Mirrors the automatic discounts in admin — display only.
      var tiersWrap = form.querySelector("[data-sc-tiers]");
      var tiers = form.querySelectorAll("[data-sc-tier]");
      var dealQty = parseInt(form.getAttribute("data-deal-qty"), 10) || 0;
      var dealOff = parseInt(form.getAttribute("data-deal-off"), 10) || 0;
      var bundleMin = parseInt(form.getAttribute("data-bundle-min"), 10) || 0;
      var bundlePct = parseInt(form.getAttribute("data-bundle-pct"), 10) || 0;
      var qtyTouched = false;

      function setQty(n) {
        if (!qtyInput) return;
        qtyInput.value = n;
        var display = form.querySelector("[data-sc-qty-val]");
        if (display) display.textContent = n;
      }
      // Best single discount for this quantity — the admin discounts don't combine,
      // so Shopify applies whichever saves more.
      function dealSaving(qty, unit) {
        var save = 0;
        if (dealQty && qty >= dealQty) save = dealOff;
        if (bundleMin && qty >= bundleMin) save = Math.max(save, Math.round(unit * qty * bundlePct / 100));
        return save;
      }

      function activePlanBtn() {
        return form.querySelector('[data-sc-plan][aria-checked="true"]') || plans[0];
      }
      function readActive() {
        var btn = activePlanBtn();
        if (!btn) {
          // no selling plans: use the form's base (variant) price
          state.plan = "";
          state.unit = parseInt(form.getAttribute("data-base-price"), 10) || 0;
          state.recurring = false;
          return;
        }
        state.plan = btn.getAttribute("data-plan-id") || "";
        state.unit = parseInt(btn.getAttribute("data-unit-price"), 10) || 0;
        state.recurring = btn.getAttribute("data-recurring") === "true";
      }
      function render() {
        readActive();
        // A subscription is always quantity 1 — hide the stepper and force qty to 1.
        // The quantity selector only applies to a one-time purchase.
        if (qtyWrap) qtyWrap.style.display = state.recurring ? "none" : "";
        // Compact buy box: the box cards already set the quantity, so the stepper only
        // appears once the largest box option is picked (to go beyond it).
        if (qtyWrap && tiersWrap && form.closest(".sc-buy--compact") && !state.recurring) {
          var lastTier = tiers.length ? parseInt(tiers[tiers.length - 1].getAttribute("data-sc-tier"), 10) : 0;
          var qNow = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
          qtyWrap.style.display = lastTier && qNow >= lastTier ? "" : "none";
        }
        if (state.recurring && qtyInput && qtyInput.value !== "1") {
          qtyInput.value = 1;
          var qtyDisplay = form.querySelector("[data-sc-qty-val]");
          if (qtyDisplay) qtyDisplay.textContent = "1";
        }
        // Deal product: a one-time buyer starts on the deal quantity until they pick
        if (tiersWrap && !state.recurring && !qtyTouched && qtyInput && qtyInput.value === "1") setQty(dealQty);
        if (tiersWrap) tiersWrap.style.display = state.recurring ? "none" : "";
        state.qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
        tiers.forEach(function (t, i) {
          var n = parseInt(t.getAttribute("data-sc-tier"), 10);
          var last = i === tiers.length - 1;
          t.setAttribute("aria-checked", String(state.qty === n || (last && state.qty > n)));
        });
        if (planInput) planInput.value = state.plan;
        if (priceEl) priceEl.textContent = formatMoney(state.unit);
        // Compact buy box: the big price follows the choice — the total for the boxes
        // picked (with the old price struck through) or the monthly price.
        var livePrice = form.parentNode.querySelector("[data-sc-price-live]");
        if (livePrice) {
          var lFull = state.unit * state.qty;
          var lSave = state.recurring ? 0 : dealSaving(state.qty, state.unit);
          if (state.recurring) {
            livePrice.innerHTML = formatMoney(state.unit) + '<small class="sc-buy__per">/ month</small>';
          } else if (lSave > 0) {
            livePrice.innerHTML = formatMoney(lFull - lSave) + '<s class="sc-buy__was">' + formatMoney(lFull) + "</s>";
          } else {
            livePrice.textContent = formatMoney(lFull);
          }
        }
        if (ctaLabel) ctaLabel.textContent = state.recurring ? (ctaLabel.getAttribute("data-sub") || "SUBSCRIBE") : (ctaLabel.getAttribute("data-one") || "ADD TO CART");
        if (ctaTotal) {
          var full = state.unit * state.qty;
          var saving = state.recurring ? 0 : dealSaving(state.qty, state.unit);
          if (saving > 0) {
            ctaTotal.innerHTML = "<s>" + formatMoney(full) + "</s> " + formatMoney(full - saving);
          } else {
            ctaTotal.textContent = formatMoney(full) + (state.recurring ? " / MO" : "");
          }
        }
        // Stepper mirrors the plan-card selected look once quantity is engaged (>1)
        if (qtyWrap) qtyWrap.classList.toggle("is-active", !state.recurring && state.qty > 1);
        // Multi-buy nudge: flips to its "met" text at 3+ one-time units.
        // Subscriptions are qty-1 by definition, so they always show the base text.
        var bundleNote = form.parentNode.querySelector("[data-sc-bundle-note]");
        if (bundleNote) {
          var met = !state.recurring && state.qty >= (bundleMin || 3) && bundleNote.getAttribute("data-met");
          if (!met && !state.recurring && dealQty && state.qty >= dealQty) met = bundleNote.getAttribute("data-deal-met");
          bundleNote.textContent = "✳︎ " + (met || bundleNote.getAttribute("data-base"));
          bundleNote.classList.toggle("is-met", !!met);
        }
      }

      // A link with ?plan=subscribe (or ?plan=one-time) opens on that purchase option
      var wantPlan = (location.search.match(/[?&]plan=([a-z-]+)/) || [])[1];
      if (wantPlan) {
        var wantBtn = form.querySelector('[data-sc-plan][data-recurring="' + (wantPlan === "subscribe" ? "true" : "false") + '"]');
        if (wantBtn) plans.forEach(function (b) { b.setAttribute("aria-checked", String(b === wantBtn)); });
      }

      plans.forEach(function (btn) {
        btn.addEventListener("click", function () {
          plans.forEach(function (b) { b.setAttribute("aria-checked", String(b === btn)); });
          render();
        });
      });

      // variant select updates base + one-time price
      var variantSelect = form.querySelector("[data-sc-variant]");
      if (variantSelect) {
        variantSelect.addEventListener("change", function () {
          var opt = variantSelect.options[variantSelect.selectedIndex];
          var price = parseInt(opt.getAttribute("data-price"), 10) || 0;
          form.setAttribute("data-base-price", price);
          var oneBtn = form.querySelector('[data-sc-plan][data-recurring="false"]');
          if (oneBtn) oneBtn.setAttribute("data-unit-price", price);
          render();
        });
      }

      // quantity steppers
      form.querySelectorAll("[data-sc-qty-btn]").forEach(function (b) {
        b.addEventListener("click", function () {
          if (!qtyInput) return;
          var delta = parseInt(b.getAttribute("data-sc-qty-btn"), 10);
          var next = Math.max(1, Math.min(9, (parseInt(qtyInput.value, 10) || 1) + delta));
          qtyTouched = true;
          setQty(next);
          render();
        });
      });

      tiers.forEach(function (t) {
        t.addEventListener("click", function () {
          qtyTouched = true;
          setQty(parseInt(t.getAttribute("data-sc-tier"), 10) || 1);
          render();
        });
      });

      // AJAX add to cart
      form.addEventListener("submit", function (e) {
        if (form.getAttribute("data-sc-ajax") !== "true") return; // let native submit if disabled
        e.preventDefault();
        var submit = form.querySelector("[data-sc-submit]");
        var original = submit ? submit.innerHTML : "";
        if (submit) submit.disabled = true;
        var body = new FormData(form);
        function showError(msg) {
          var note = form.querySelector("[data-sc-form-error]");
          if (!note) {
            note = document.createElement("p");
            note.setAttribute("data-sc-form-error", "");
            note.className = "sc-form-error";
            form.appendChild(note);
          }
          note.textContent = msg;
        }
        fetch("/cart/add.js", { method: "POST", headers: { "Accept": "application/json" }, body: body })
          .then(function (r) {
            // Surface Shopify's real error (e.g. sold out / invalid plan) instead of
            // bouncing to an empty cart page.
            if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || "Couldn't add to cart"); });
            return r.json();
          })
          .then(function () {
            var note = form.querySelector("[data-sc-form-error]");
            if (note) note.remove();
            if (submit) { submit.innerHTML = "ADDED ✓"; }
            refreshCartCount();
            if (window.SCCartDrawer) window.SCCartDrawer.open();
            setTimeout(function () { if (submit) { submit.innerHTML = original; submit.disabled = false; } }, 1600);
          })
          .catch(function (err) {
            if (submit) { submit.innerHTML = original; submit.disabled = false; }
            showError(err && err.message ? err.message : "Couldn't add to cart — please try again.");
          });
      });

      render();
      initStickyBuy(form);
    });
  }

  /* Phone sticky buy bar — shown while the main add-to-cart button is off screen
     (scrolled past it, not before it). Mirrors the main button's label and submits
     the main form, so plan, quantity and the AJAX add stay in one place. */
  function initStickyBuy(form) {
    var bar = form.parentNode.querySelector("[data-sc-sticky-buy]");
    var main = form.querySelector("[data-sc-submit]");
    if (!bar || !main || !("IntersectionObserver" in window)) return;
    var btn = bar.querySelector("[data-sc-sticky-btn]");
    function sync() {
      btn.innerHTML = main.innerHTML;
      btn.disabled = main.disabled;
    }
    sync();
    new MutationObserver(sync).observe(main, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ["disabled"] });
    btn.addEventListener("click", function () {
      if (form.requestSubmit) form.requestSubmit(main); else main.click();
    });
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var show = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle("is-visible", show);
      bar.setAttribute("aria-hidden", String(!show));
      btn.tabIndex = show ? 0 : -1;
      document.body.classList.toggle("has-sticky-buy", show);
    }).observe(main);
  }

  /* ---------- peel to win popup ---------- */
  function initPeel() {
    // Editor re-render safety: a previously-opened popup was reparented to
    // <body>; drop it before binding the freshly rendered section.
    document.querySelectorAll("[data-sc-peel-moved]").forEach(function (el) { el.remove(); });
    var root = document.querySelector("[data-sc-peel]");
    if (!root || root.__scPeelBound) return;
    root.__scPeelBound = true;

    var design = !!(window.Shopify && window.Shopify.designMode);
    // Test bypass: ?peel on the URL force-opens the popup and ignores the
    // frequency cap. Invisible to normal visitors; handy for previewing.
    var forced = false;
    try { forced = new URLSearchParams(window.location.search).has("peel"); } catch (e) {}
    var preview = design || forced;
    var STORE_KEY = "sc_peel_v1";

    function readStore() {
      try { return JSON.parse(localStorage.getItem(STORE_KEY)) || {}; }
      catch (e) { return {}; }
    }
    function writeStore(patch) {
      var next = readStore();
      for (var k in patch) next[k] = patch[k];
      try { localStorage.setItem(STORE_KEY, JSON.stringify(next)); } catch (e) {}
      return next;
    }

    var prizes = [];
    try {
      var raw = root.querySelector("[data-sc-peel-prizes]");
      prizes = (JSON.parse(raw.textContent) || []).filter(function (p) {
        return p && p.code && (p.weight | 0) > 0;
      });
    } catch (e) { prizes = []; }
    if (!prizes.length) return; // nothing real to give away

    var pouch = root.querySelector("[data-sc-peel-pouch]");
    var foil = root.querySelector("[data-sc-peel-foil]");
    var tab = root.querySelector("[data-sc-peel-tab]");
    var revealEl = root.querySelector("[data-sc-peel-reveal]");
    var expiryMin = parseInt(root.getAttribute("data-expiry"), 10) || 0;
    var freqDays = parseInt(root.getAttribute("data-frequency"), 10) || 0;

    var picked = null;      // chosen prize (locked in on first interaction)
    var peeled = false;     // reveal fired

    function stage(name) {
      root.querySelectorAll("[data-sc-peel-stage]").forEach(function (s) {
        s.hidden = s.getAttribute("data-sc-peel-stage") !== name;
      });
    }

    function pickPrize() {
      var total = prizes.reduce(function (s, p) { return s + (p.weight | 0); }, 0);
      var r = Math.random() * total;
      for (var i = 0; i < prizes.length; i++) {
        r -= prizes[i].weight | 0;
        if (r < 0) return prizes[i];
      }
      return prizes[prizes.length - 1];
    }

    /* ----- open / close ----- */
    function open() {
      // Reparent to <body> so no transformed/contained ancestor (Shopify's
      // editor wrapper, footer animations) can trap the position:fixed overlay
      // and collapse it into a sliver.
      if (root.parentNode !== document.body) {
        root.setAttribute("data-sc-peel-moved", "");
        document.body.appendChild(root);
      }
      root.hidden = false;
      // force reflow so the transition runs
      void root.offsetWidth;
      root.classList.add("is-open");
      document.documentElement.style.overflow = "hidden";
      var modal = root.querySelector(".sc-peel__modal");
      if (modal) { try { modal.focus({ preventScroll: true }); } catch (e) { modal.focus(); } }
      if (!preview) {
        var next = freqDays > 0 ? Date.now() + freqDays * 864e5 : 0;
        writeStore({ seenAt: Date.now(), nextEligibleAt: next });
      }
    }
    function close() {
      root.classList.remove("is-open");
      document.documentElement.style.overflow = "";
      setTimeout(function () { if (!root.classList.contains("is-open")) root.hidden = true; }, 340);
    }
    root.querySelectorAll("[data-sc-peel-close]").forEach(function (el) {
      el.addEventListener("click", close);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && root.classList.contains("is-open")) close();
    });

    /* ----- the peel ----- */
    function setFoil(p) {
      // p: 0 (sealed) .. 1 (fully lifted). Peels from the right (tab) edge.
      foil.style.transform = "perspective(700px) rotateY(" + (-p * 105) + "deg)";
    }
    function beginInteraction() {
      if (picked) return;
      picked = pickPrize();
      if (revealEl) revealEl.textContent = picked.label || "Prize";
      pouch.classList.add("is-peeling");
    }
    function complete() {
      if (peeled) return;
      peeled = true;
      pouch.classList.remove("is-peeling");
      pouch.classList.add("is-revealed");
      foil.style.transform = "perspective(700px) rotateY(-105deg)";
      // Let the revealed prize linger so the win registers before the email step.
      setTimeout(toClaim, 1800);
    }
    function tween(from, to, ms, done) {
      var start = null;
      function frame(t) {
        if (start === null) start = t;
        var k = Math.min(1, (t - start) / ms);
        var eased = 1 - Math.pow(1 - k, 3);
        setFoil(from + (to - from) * eased);
        if (k < 1) requestAnimationFrame(frame); else if (done) done();
      }
      requestAnimationFrame(frame);
    }
    function autoPeel() {
      beginInteraction();
      foil.style.transition = "none";
      tween(0, 1, 520, complete);
    }

    // pointer drag
    var dragging = false, startX = 0, moved = 0, prog = 0;
    function onDown(e) {
      if (peeled) return;
      dragging = true; moved = 0; prog = 0;
      startX = e.clientX != null ? e.clientX : (e.touches && e.touches[0].clientX) || 0;
      beginInteraction();
      foil.style.transition = "none";
      if (tab && tab.setPointerCapture && e.pointerId != null) {
        try { tab.setPointerCapture(e.pointerId); } catch (err) {}
      }
    }
    function onMove(e) {
      if (!dragging) return;
      var x = e.clientX != null ? e.clientX : (e.touches && e.touches[0].clientX) || 0;
      var dx = startX - x;               // leftward drag peels
      moved = Math.abs(dx);
      prog = Math.max(0, Math.min(1, dx / (pouch.offsetWidth * 0.72)));
      setFoil(prog);
      if (e.cancelable) e.preventDefault();
    }
    function onUp() {
      if (!dragging) return;
      dragging = false;
      if (moved < 6) { autoPeel(); return; }        // treated as a tap
      if (prog > 0.5) { tween(prog, 1, 240, complete); }
      else { foil.style.transition = "transform 0.3s ease"; setFoil(0); picked = null; pouch.classList.remove("is-peeling"); }
    }

    // Prefer pointer events; fall back to touch/mouse
    if (window.PointerEvent) {
      tab.addEventListener("pointerdown", onDown);
      foil.addEventListener("pointerdown", onDown);
      document.addEventListener("pointermove", onMove);
      document.addEventListener("pointerup", onUp);
    } else {
      tab.addEventListener("mousedown", onDown);
      foil.addEventListener("mousedown", onDown);
      document.addEventListener("mousemove", onMove);
      document.addEventListener("mouseup", onUp);
      tab.addEventListener("touchstart", onDown, { passive: true });
      document.addEventListener("touchmove", onMove, { passive: false });
      document.addEventListener("touchend", onUp);
    }
    // keyboard
    tab.addEventListener("keydown", function (e) {
      if ((e.key === "Enter" || e.key === " ") && !peeled) { e.preventDefault(); autoPeel(); }
    });

    /* ----- claim (email unlocks the code) ----- */
    function toClaim() {
      stage("claim");
      var lbl = root.querySelector("[data-sc-peel-won-label]");
      var desc = root.querySelector("[data-sc-peel-won-desc]");
      if (lbl) lbl.textContent = picked.label || "Your prize";
      if (desc) desc.textContent = picked.desc || "";
    }

    var form = root.querySelector("[data-sc-peel-form]") || root.querySelector('[data-sc-peel-stage="claim"] form');
    if (form) {
      var emailInput = form.querySelector('input[type="email"]');
      var submitBtn = form.querySelector("[data-sc-peel-submit]");

      // Submit NATIVELY (like the footer newsletter) so Shopify actually creates
      // the customer — a background fetch to the customer form does not reliably
      // persist. Stash the won prize first; after the post + reload we restore
      // the popup straight to the unlocked-code stage (see the restore check on
      // load below).
      form.addEventListener("submit", function (e) {
        if (emailInput && !emailInput.checkValidity()) { e.preventDefault(); emailInput.reportValidity(); return; }
        if (picked) {
          writeStore({
            pending: { code: picked.code, label: picked.label, cta: picked.cta, desc: picked.desc },
            pendingAt: Date.now()
          });
        }
        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = "…"; }
        // no preventDefault → the form posts natively and the page reloads
      });
    }

    /* ----- done (code unlocked) ----- */
    function discountLink(code, cta) {
      var redirect = cta || "/collections/all";
      return "/discount/" + encodeURIComponent(code) + "?redirect=" + encodeURIComponent(redirect);
    }
    function toDone() {
      var expiresAt = expiryMin > 0 ? Date.now() + expiryMin * 60000 : 0;
      if (!preview) writeStore({ claimed: true, code: picked.code, label: picked.label, expiresAt: expiresAt });
      stage("done");
      var lbl = root.querySelector("[data-sc-peel-done-label]");
      var live = root.querySelector("[data-sc-peel-code-live]");
      var shop = root.querySelector("[data-sc-peel-shop]");
      if (lbl) lbl.textContent = picked.label || "";
      if (live) live.textContent = picked.code;
      if (shop) shop.setAttribute("href", discountLink(picked.code, picked.cta));
      if (expiresAt) startCountdown(expiresAt);
    }

    var copyBtn = root.querySelector("[data-sc-peel-copy]");
    if (copyBtn) {
      copyBtn.addEventListener("click", function () {
        var code = picked ? picked.code : "";
        var label = root.querySelector("[data-sc-peel-copy-label]");
        function flash() { if (label) { label.textContent = "COPIED ✓"; setTimeout(function () { label.textContent = "COPY"; }, 1600); } }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(flash).catch(flash);
        } else { flash(); }
      });
    }

    function startCountdown(expiresAt) {
      var el = root.querySelector("[data-sc-peel-expiry]");
      if (!el) return;
      el.hidden = false;
      function tick() {
        var left = expiresAt - Date.now();
        if (left <= 0) { el.textContent = "Offer expired — but your code may still work."; return; }
        var m = Math.floor(left / 60000), s = Math.floor((left % 60000) / 1000);
        el.textContent = "Yours for " + m + ":" + (s < 10 ? "0" : "") + s;
        setTimeout(tick, 1000);
      }
      tick();
    }

    /* ----- restore after a native customer-form post + reload ----- */
    // Shopify renders [data-sc-peel-posted] only on the single render right
    // after a successful submit; paired with the prize we stashed just before
    // the native post, reopen straight to the unlocked-code stage.
    var justPosted = !!root.querySelector("[data-sc-peel-posted]");
    var pstore = readStore();
    if (justPosted && pstore.pending && pstore.pending.code &&
        pstore.pendingAt && (Date.now() - pstore.pendingAt) < 600000) {
      picked = pstore.pending;
      peeled = true;
      writeStore({ pending: null, claimed: true, code: picked.code, label: picked.label });
      // The customer form carries a #contact_form anchor; strip it and reset
      // scroll so the page underneath the popup isn't jumped down the page.
      if (window.history && history.replaceState && window.location.hash) {
        history.replaceState(null, "", window.location.pathname + window.location.search);
      }
      window.scrollTo(0, 0);
      open();
      toDone();
      return;
    }

    /* ----- trigger ----- */
    function eligible() {
      if (preview) return true;
      var store = readStore();
      if (store.nextEligibleAt && Date.now() < store.nextEligibleAt) return false;
      return true;
    }
    if (preview) { open(); return; }
    if (!eligible()) return;

    var fired = false;
    function fire() { if (fired) return; fired = true; open(); }
    var trigger = root.getAttribute("data-trigger") || "both";
    var delay = parseInt(root.getAttribute("data-delay"), 10);
    if (isNaN(delay)) delay = 12;

    if (trigger === "delay" || trigger === "both") {
      setTimeout(fire, delay * 1000);
    }
    if (trigger === "exit" || trigger === "both") {
      document.addEventListener("mouseout", function (e) {
        if (!e.relatedTarget && e.clientY <= 0) fire();
      });
    }
  }


  /* ---------- soft fade-in for lazy photos ---------- */
  function initImageFade() {
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    document.documentElement.classList.add("sc-fade");
    document.querySelectorAll('main img[loading="lazy"]:not(.sc-fade-in)').forEach(function (img) {
      if (img.complete && img.naturalWidth) return; // already there — leave it
      img.classList.add("sc-fade-in");
      function done() { img.classList.add("is-loaded"); }
      img.addEventListener("load", done, { once: true });
      img.addEventListener("error", done, { once: true });
    });
  }

  /* ---------- header cart count ---------- */
  function refreshCartCount() {
    fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll("[data-sc-cart-count]").forEach(function (el) {
          el.textContent = cart.item_count;
          var wrap = el.closest(".sc-cart-quick__count, .sc-util__count");
          if (wrap) wrap.classList.toggle("is-empty", cart.item_count === 0);
        });
      })
      .catch(function () {});
  }


  /* ---------- slide-in cart drawer (snippets/cart-drawer.liquid) ----------
     Rendered from /cart.js each time it opens or changes. Free-shipping bar from the
     theme setting; a "make it 2 for €49" nudge when the deal product is in the cart
     below the deal quantity. */
  function initCartDrawer() {
    var root = document.querySelector("[data-sc-cdrawer]");
    if (!root) return;
    if (root.dataset.scInit) {
      // theme editor re-render: only wire any new header cart links
      document.querySelectorAll("[data-sc-cart-open]:not([data-sc-wired])").forEach(function (a) {
        a.setAttribute("data-sc-wired", ""); a.addEventListener("click", function (e) { if (e.metaKey || e.ctrlKey) return; e.preventDefault(); window.SCCartDrawer.open(); });
      });
      return;
    }
    root.dataset.scInit = "1";
    // Discount code: pre-fill a code won in the peel game (and open the field)
    var codeBox = root.querySelector("[data-sc-cdrawer-code]");
    if (codeBox) {
      try {
        var peel = JSON.parse(localStorage.getItem("sc_peel_v1")) || {};
        var codeInput = codeBox.querySelector("input[name=discount]");
        if (peel.claimed && peel.code && codeInput && !codeInput.value) { codeInput.value = peel.code; codeBox.open = true; }
      } catch (e) {}
    }
    var body = root.querySelector("[data-sc-cdrawer-body]");
    var foot = root.querySelector("[data-sc-cdrawer-foot]");
    var totalEl = root.querySelector("[data-sc-cdrawer-total]");
    var shipText = root.querySelector("[data-sc-cdrawer-ship-text]");
    var bar = root.querySelector("[data-sc-cdrawer-bar]");
    var threshold = parseInt(root.getAttribute("data-threshold"), 10) || 0;
    var dealHandle = root.getAttribute("data-deal-handle") || "";
    var dealQty = parseInt(root.getAttribute("data-deal-qty"), 10) || 2;
    var dealOff = parseInt(root.getAttribute("data-deal-off"), 10) || 0;
    var lastFocus = null;

    function esc(t) { var d = document.createElement("div"); d.textContent = t == null ? "" : String(t); return d.innerHTML; }
    function img(url, w) { if (!url) return ""; return url + (url.indexOf("?") > -1 ? "&" : "?") + "width=" + w; }

    function render(cart) {
      var items = cart.items || [];
      if (!items.length) {
        body.innerHTML = '<div class="sc-cdrawer__empty"><p class="sc-cdrawer__empty-h">Nothing here yet.</p><p class="sc-cdrawer__empty-sub">Just strip it.</p><a class="sc-btn sc-btn--primary" href="/collections/all">SHOP THE STRIPS</a></div>';
        foot.hidden = true;
      } else {
        foot.hidden = false;
        var html = "";
        items.forEach(function (it, i) {
          var line = i + 1;
          var sub = it.selling_plan_allocation ? it.selling_plan_allocation.selling_plan.name : (it.variant_title && it.variant_title !== "Default Title" ? it.variant_title : "");
          var was = it.original_line_price > it.final_line_price ? '<s>' + formatMoney(it.original_line_price) + '</s>' : "";
          html += '<div class="sc-cdrawer__line">' +
            '<a class="sc-cdrawer__thumb" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(img(it.image, 200)) + '" alt="" loading="lazy">' : "") + '</a>' +
            '<div class="sc-cdrawer__info"><a class="sc-cdrawer__name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
            (sub ? '<span class="sc-cdrawer__sub">' + esc(sub) + '</span>' : "") +
            '<div class="sc-cdrawer__row"><span class="sc-cdrawer__qty"><button type="button" data-line="' + line + '" data-qty="' + (it.quantity - 1) + '" aria-label="Decrease">−</button><span>' + it.quantity + '</span><button type="button" data-line="' + line + '" data-qty="' + (it.quantity + 1) + '" aria-label="Increase">+</button></span>' +
            '<span class="sc-cdrawer__price">' + was + formatMoney(it.final_line_price) + '</span></div>' +
            '<button type="button" class="sc-cdrawer__remove" data-line="' + line + '" data-qty="0">remove</button></div></div>';
        });
        // "make it 2" nudge for the deal product
        if (dealHandle && dealOff) {
          items.forEach(function (it, i) {
            if (it.handle === dealHandle && !it.selling_plan_allocation && it.quantity < dealQty) {
              var dealTotal = it.price * dealQty - dealOff;
              html += '<button type="button" class="sc-cdrawer__nudge" data-line="' + (i + 1) + '" data-qty="' + dealQty + '">' +
                '<span class="sc-cdrawer__nudge-tag">✳︎ the deal</span><span class="sc-cdrawer__nudge-text">Make it ' + dealQty + ' boxes for ' + formatMoney(dealTotal) + '</span><span class="sc-cdrawer__nudge-add">ADD +</span></button>';
            }
          });
        }
        body.innerHTML = html;
        var total = formatMoney(cart.total_price);
        totalEl.innerHTML = (cart.original_total_price > cart.total_price ? '<s>' + formatMoney(cart.original_total_price) + '</s> ' : "") + total;
      }
      if (shipText && bar) {
        var left = threshold - cart.total_price;
        if (!items.length) { shipText.innerHTML = 'Free shipping from ' + formatMoney(threshold); bar.style.width = "0%"; }
        else if (left > 0) { shipText.innerHTML = 'You’re <strong>' + formatMoney(left) + '</strong> away from free shipping'; bar.style.width = Math.min(100, cart.total_price / threshold * 100) + "%"; }
        else { shipText.innerHTML = '<strong>Free shipping</strong> unlocked ✳︎'; bar.style.width = "100%"; }
        var shipBox = root.querySelector("[data-sc-cdrawer-ship]");
        if (shipBox) shipBox.classList.toggle("is-free", !!items.length && left <= 0);
      }
    }

    function load() {
      return fetch("/cart.js", { headers: { "Accept": "application/json" } }).then(function (r) { return r.json(); }).then(render);
    }
    function change(line, qty) {
      root.classList.add("is-busy");
      fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify({ line: line, quantity: qty }) })
        .then(function (r) { return r.json(); })
        .then(function (cart) { render(cart); refreshCartCount(); })
        .catch(function () {})
        .then(function () { root.classList.remove("is-busy"); });
    }
    function open() {
      lastFocus = document.activeElement;
      root.hidden = false;
      load().catch(function () {});
      requestAnimationFrame(function () { root.classList.add("is-open"); });
      document.documentElement.classList.add("sc-noscroll");
      var x = root.querySelector(".sc-cdrawer__x"); if (x) setTimeout(function () { x.focus(); }, 50);
    }
    function close() {
      root.classList.remove("is-open");
      document.documentElement.classList.remove("sc-noscroll");
      setTimeout(function () { if (!root.classList.contains("is-open")) root.hidden = true; }, 350);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    root.addEventListener("click", function (e) {
      var t = e.target.closest("[data-sc-cdrawer-close]");
      if (t) { close(); return; }
      var b = e.target.closest("[data-line]");
      if (b) change(parseInt(b.getAttribute("data-line"), 10), Math.max(0, parseInt(b.getAttribute("data-qty"), 10) || 0));
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && root.classList.contains("is-open")) close(); });
    document.querySelectorAll("[data-sc-cart-open]").forEach(function (a) {
      a.setAttribute("data-sc-wired", "");
      a.addEventListener("click", function (e) { if (e.metaKey || e.ctrlKey) return; e.preventDefault(); open(); });
    });
    window.SCCartDrawer = { open: open, close: close };
  }

  /* ---------- cart page (steppers + remove via /cart/change.js) ---------- */
  function initCart() {
    var root = document.querySelector("[data-sc-cart]");
    if (!root) return;

    function change(line, quantity) {
      root.classList.add("sc-cart--busy");
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function () { window.location.reload(); })
        .catch(function () { window.location.reload(); });
    }

    root.addEventListener("click", function (e) {
      var stepper = e.target.closest("[data-sc-line-qty]");
      if (stepper) {
        var line = parseInt(stepper.getAttribute("data-line"), 10);
        var current = parseInt(stepper.getAttribute("data-current"), 10);
        var delta = parseInt(stepper.getAttribute("data-sc-line-qty"), 10);
        change(line, Math.max(0, current + delta));
        return;
      }
      var remove = e.target.closest("[data-sc-line-remove]");
      if (remove) {
        change(parseInt(remove.getAttribute("data-line"), 10), 0);
      }
    });
  }

  // Stats band: count the big numbers up from 0 the first time they scroll into
  // view. Non-numeric parts are kept as-is ("24/7" counts the 24, "~15" keeps ~).
  // Skipped under prefers-reduced-motion (values just show finished).
  function initStatCounters() {
    if (!("IntersectionObserver" in window)) return;
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    var els = document.querySelectorAll(".sc-stat__value");
    if (!els.length) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        run(entry.target);
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) {
      if (el.dataset.scCount === "on") return;
      var m = el.textContent.trim().match(/^([^0-9]*)(\d+)(.*)$/);
      if (!m || parseInt(m[2], 10) === 0) return; // nothing to count
      el.dataset.scCount = "on";
      el.dataset.scPrefix = m[1];
      el.dataset.scTarget = m[2];
      el.dataset.scSuffix = m[3];
      // Reserve the final width so the layout doesn't wobble while counting
      el.style.display = "inline-block";
      el.style.minWidth = el.offsetWidth + "px";
      el.textContent = m[1] + "0" + m[3];
      observer.observe(el);
    });
    function run(el) {
      var target = parseInt(el.dataset.scTarget, 10);
      var prefix = el.dataset.scPrefix || "", suffix = el.dataset.scSuffix || "";
      var duration = 1300, start = null;
      function frame(ts) {
        if (start === null) start = ts;
        var p = Math.min(1, (ts - start) / duration);
        var eased = 1 - Math.pow(1 - p, 3); // ease-out cubic
        el.textContent = prefix + Math.round(eased * target) + suffix;
        if (p < 1) requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }
  }

  // Mobile hamburger drawer: toggle the nav panel under the header bar.
  // Floating-bar header: the bar rides normally with the page, then hides when
  // scrolling down and reappears when scrolling up. Sticky is applied to the
  // header GROUP shell (the direct child of <body> that contains the bar) so it
  // can travel the full page height — sticky on .sc-header alone is trapped in
  // its own section wrapper and just scrolls away.
  function initStickyHeader() {
    var bar = document.querySelector(".sc-header--bar");
    if (!bar) return;
    var shell = bar, p = bar.parentElement;
    while (p && p !== document.body) { shell = p; p = p.parentElement; }
    if (shell.dataset.scSticky === "on") return;
    shell.dataset.scSticky = "on";
    shell.style.position = "sticky";
    shell.style.top = "0";
    shell.style.zIndex = "50";
    shell.classList.add("sc-nav-shell");
    // Expose the capsule's height so a full-screen hero can slide up underneath it
    // (photo runs behind the floating nav). Re-measured on resize.
    function measureBar() {
      document.documentElement.style.setProperty("--sc-bar-h", bar.offsetHeight + "px");
    }
    measureBar();
    window.addEventListener("resize", measureBar, { passive: true });
    var header = document.querySelector(".sc-header");
    var last = window.pageYOffset || 0;
    var ticking = false;
    function update() {
      var y = window.pageYOffset || 0;
      // Turn the capsule white (red logo) once scrolled off the very top.
      if (header) header.classList.toggle("is-scrolled", y > 40);
      // Stay visible well down the page before hiding; always show while a menu is open.
      if (y < 340 || (header && header.classList.contains("is-open"))) {
        shell.classList.remove("sc-nav-hidden");
      } else if (y > last + 6) {
        shell.classList.add("sc-nav-hidden");       // scrolling down → hide
      } else if (y < last - 6) {
        shell.classList.remove("sc-nav-hidden");    // scrolling up → reveal
      }
      last = y;
      ticking = false;
    }
    update();
    window.addEventListener("scroll", function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
  }

  function initMenu() {
    var header = document.querySelector(".sc-header");
    if (!header || header.dataset.scMenu === "on") return;
    var btn = header.querySelector("[data-sc-menu-toggle]");
    if (!btn) return;
    header.dataset.scMenu = "on";

    function collapseScience() {
      header.querySelectorAll(".sc-drawer .sc-science.is-expanded").forEach(function (el) { el.classList.remove("is-expanded"); });
    }
    function close() {
      header.classList.remove("is-open");
      btn.setAttribute("aria-expanded", "false");
      collapseScience(); // the menu always reopens compact
    }
    btn.addEventListener("click", function (e) {
      e.stopPropagation();
      var open = header.classList.toggle("is-open");
      btn.setAttribute("aria-expanded", open ? "true" : "false");
    });
    // On mobile, a trigger that owns a mega-menu (SHOP / THE SCIENCE) expands it
    // inline instead of navigating; every other drawer link just closes the panel.
    header.querySelectorAll(".sc-drawer .sc-shop__trigger").forEach(function (t) {
      var parent = t.closest(".sc-shop");
      if (!parent || !parent.querySelector(".sc-shop__menu")) return;
      t.addEventListener("click", function (e) {
        if (window.innerWidth <= 560) {
          e.preventDefault();
          e.stopPropagation();
          var opening = !parent.classList.contains("is-expanded");
          parent.classList.toggle("is-expanded");
          // Opening the science list: bring it into view if the menu has to scroll on a small phone
          if (opening && parent.classList.contains("sc-science")) {
            var list = parent.querySelector(".sc-shop__menu");
            if (list && list.scrollIntoView) setTimeout(function () { list.scrollIntoView({ block: "nearest", behavior: "smooth" }); }, 30);
          }
        }
      });
    });
    // Close after picking a destination, clicking away, hitting Escape, or widening to desktop.
    header.querySelectorAll(".sc-drawer a:not(.sc-shop__trigger):not([data-sc-need-row])").forEach(function (a) {
      a.addEventListener("click", close);
    });
    document.addEventListener("click", function (e) {
      if (header.classList.contains("is-open") && !header.contains(e.target)) close();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") close();
    });
    window.addEventListener("resize", function () {
      if (window.innerWidth > 560) close();
    });
  }

  // Gentle auto-drift on a native scroll container that can also be swiped / dragged
  // by hand. `vp` is the scroll element, `track` holds the items (a doubled set whose
  // second half makes the loop seamless), `itemSel` selects the repeated items.
  function driftCarousel(vp, track, itemSel, speed) {
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)");
    var items = track.querySelectorAll(itemSel);
    if (items.length < 2) return;
    var half = Math.floor(items.length / 2);

    var loop = 0; // width of one set — the seamless wrap distance
    function measure() { loop = items[half].offsetLeft - items[0].offsetLeft; }
    measure();
    window.addEventListener("resize", measure);
    window.addEventListener("load", measure);

    var paused = false, dragging = false, startX = 0, startScroll = 0, moved = false;
    // Float accumulator: scrollLeft is often integer-rounded, so a sub-pixel
    // increment written straight to it never accrues.
    var pos = vp.scrollLeft;
    function scrollable() { return vp.scrollWidth - vp.clientWidth > 4; }

    function frame() {
      if (!paused && !dragging && loop > 0 && scrollable() && !(reduce && reduce.matches)) {
        pos += speed;
        if (pos >= loop) pos -= loop; // wrap forward, seamlessly
        vp.scrollLeft = pos;
      } else {
        pos = vp.scrollLeft; // user is in control (or not scrollable) — stay in sync
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);

    // Pause the drift on interaction, resume after a short idle so a swipe's
    // momentum fling can finish instead of being overwritten mid-flick.
    var resumeTimer = null;
    function pause() { paused = true; if (resumeTimer) { clearTimeout(resumeTimer); resumeTimer = null; } }
    function resumeSoon(delay) {
      if (resumeTimer) clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () { paused = false; resumeTimer = null; }, delay);
    }

    vp.addEventListener("mouseenter", pause);
    vp.addEventListener("mouseleave", function () { if (!dragging) resumeSoon(500); });
    vp.addEventListener("touchstart", pause, { passive: true });
    vp.addEventListener("touchend", function () { resumeSoon(1600); }, { passive: true });

    // Click-and-drag to scroll (mouse only — touch uses native momentum scroll).
    vp.addEventListener("pointerdown", function (e) {
      pause();
      if (e.pointerType !== "mouse" || !scrollable()) return;
      dragging = true; moved = false;
      startX = e.clientX; startScroll = vp.scrollLeft;
      vp.classList.add("is-dragging");
    });
    vp.addEventListener("pointermove", function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      // Capture the pointer only once a real drag starts — capturing on pointerdown
      // redirects the eventual click to the viewport, which kills plain clicks on
      // the card links (images stopped navigating).
      if (!moved && Math.abs(dx) > 4) {
        moved = true;
        try { vp.setPointerCapture(e.pointerId); } catch (err) {}
      }
      if (moved) vp.scrollLeft = startScroll - dx;
    });
    function endDrag() {
      if (dragging) { dragging = false; vp.classList.remove("is-dragging"); }
      resumeSoon(1200);
    }
    vp.addEventListener("pointerup", endDrag);
    vp.addEventListener("pointercancel", endDrag);
    // Swallow the click that follows a real drag so it doesn't open the card.
    vp.addEventListener("click", function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
  }

  // Card detail panel on touch: the + button toggles it (hover covers desktop).
  function initCardInfo() {
    document.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-sc-card-info]");
      if (btn) {
        e.preventDefault();
        e.stopPropagation();
        var card = btn.closest(".sc-card");
        var open = card.classList.contains("is-open");
        document.querySelectorAll(".sc-card.is-open").forEach(function (c) { c.classList.remove("is-open"); });
        if (!open) card.classList.add("is-open");
        return;
      }
      // tapping anywhere else closes an open panel (without eating the tap)
      document.querySelectorAll(".sc-card.is-open").forEach(function (c) { c.classList.remove("is-open"); });
    }, true);
  }

  // "THE STRIPS" product row.
  function initStripsCarousel() {
    document.querySelectorAll(".sc-strips__viewport").forEach(function (vp) {
      if (vp.dataset.scDrift === "on") return;
      vp.dataset.scDrift = "on";
      var track = vp.querySelector(".sc-strips__track");
      if (track) driftCarousel(vp, track, ".sc-card", 1.1);
      // The duplicated loop set stays clickable/hoverable (no `inert` — it would
      // kill mouse interaction on the second cycle) but leaves the tab order,
      // so keyboard users don't traverse every card twice.
      vp.querySelectorAll(".sc-strips__loop a, .sc-strips__loop button").forEach(function (el) {
        el.tabIndex = -1;
      });
    });
  }

  // Science-page photo collage → drift + swipe on mobile (a static grid on desktop,
  // where it isn't scrollable, so the drift stays idle).
  function initCollageCarousel() {
    document.querySelectorAll(".sc-collage").forEach(function (vp) {
      if (vp.dataset.scDrift === "on") return;
      vp.dataset.scDrift = "on";
      driftCarousel(vp, vp, ".sc-collage__item", 0.8);
    });
  }

  // Social band — tiles linking to a TikTok post. The post's cover is fetched via
  // TikTok's public oEmbed endpoint (only when no image is uploaded), and a click
  // swaps in TikTok's player iframe right in the tile — the heavy embed loads for
  // the one tile the visitor taps, never on page load. Falls back to a plain link
  // to TikTok when the video id can't be resolved.
  function initSocialEmbeds() {
    document.querySelectorAll("[data-sc-tiktok]").forEach(function (tile) {
      var url = tile.getAttribute("data-sc-tiktok");
      tile.removeAttribute("data-sc-tiktok");
      var m = url.match(/\/video\/(\d+)/);
      var videoId = m ? m[1] : null;
      var needThumb = !!tile.querySelector(".sc-social__ph");

      function openPlayer() {
        var ov = document.createElement("div");
        ov.className = "sc-tiktok-ov";
        ov.innerHTML =
          '<div class="sc-tiktok-ov__box">' +
          '<button type="button" class="sc-tiktok-ov__close" aria-label="Close">×</button>' +
          '<iframe src="https://www.tiktok.com/player/v1/' + videoId + '?autoplay=1&rel=0"' +
          ' allow="autoplay; encrypted-media; fullscreen" allowfullscreen title="TikTok video — @stripclubcare"></iframe>' +
          '<a class="sc-tiktok-ov__link" href="' + url + '" target="_blank" rel="noopener">watch on TikTok ↗︎</a>' +
          "</div>";
        function close() {
          document.removeEventListener("keydown", onKey);
          document.body.style.overflow = "";
          ov.remove();
        }
        function onKey(e) { if (e.key === "Escape") close(); }
        ov.addEventListener("click", function (e) {
          if (e.target === ov || e.target.classList.contains("sc-tiktok-ov__close")) close();
        });
        document.addEventListener("keydown", onKey);
        document.body.style.overflow = "hidden";
        document.body.appendChild(ov);
      }

      function armPlay() {
        if (tile.dataset.scPlayable) return;
        tile.dataset.scPlayable = "1";
        tile.classList.add("sc-social__tile--playable");
        tile.addEventListener("click", function (e) {
          e.preventDefault();
          openPlayer();
        });
      }

      if (videoId && !needThumb) {
        armPlay();
        return;
      }
      // Need the oEmbed call: for the cover image, the video id (short links), or both.
      fetch("https://www.tiktok.com/oembed?url=" + encodeURIComponent(url))
        .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
        .then(function (data) {
          if (!data) return;
          if (!videoId && data.embed_product_id) videoId = String(data.embed_product_id);
          if (videoId) armPlay();
          if (needThumb && data.thumbnail_url) {
            var img = new Image();
            img.alt = data.title ? String(data.title).slice(0, 120) : "@stripclubcare on TikTok";
            img.decoding = "async";
            img.onload = function () {
              var ph = tile.querySelector(".sc-social__ph");
              var frame = tile.querySelector(".sc-social__frame");
              if (frame) frame.style.setProperty("--sc-bg", 'url("' + data.thumbnail_url + '")');
              if (ph) ph.replaceWith(img);
            };
            img.src = data.thumbnail_url;
          }
        })
        .catch(function () { if (videoId) armPlay(); });
    });
  }

  // Instagram post/reel tiles. Instagram has no public cover API, so with no image
  // set the tile shows Instagram's own embed of the post (header cropped off,
  // non-interactive so the tile stays one tap target), loaded when near view.
  // A click opens the full embed in the same overlay the TikTok tiles use.
  // Social band desktop row: ← → buttons scroll by roughly one view
  function initSocialArrows() {
    document.querySelectorAll("[data-sc-social-arrows]").forEach(function (box) {
      if (box.dataset.scBound) return;
      box.dataset.scBound = "1";
      var section = box.closest(".sc-social");
      var row = section && section.querySelector(".sc-social__grid--row");
      if (!row) return;
      var btns = box.querySelectorAll("[data-dir]");
      function update() {
        var max = row.scrollWidth - row.clientWidth - 2;
        btns[0].disabled = row.scrollLeft <= 2;
        btns[1].disabled = row.scrollLeft >= max;
      }
      btns.forEach(function (b) {
        b.addEventListener("click", function () {
          row.scrollBy({ left: parseInt(b.getAttribute("data-dir"), 10) * row.clientWidth * 0.8, behavior: "smooth" });
        });
      });
      row.addEventListener("scroll", update, { passive: true });
      window.addEventListener("resize", update, { passive: true });
      update();
    });
  }

  function initInstagramTiles() {
    var tiles = document.querySelectorAll("[data-sc-instagram]");
    if (!tiles.length) return;
    function embedUrl(url) {
      var m = url.match(/instagram\.com\/(p|reel|reels|tv)\/([A-Za-z0-9_-]+)/);
      if (!m) return null;
      var kind = m[1] === "reels" ? "reel" : m[1];
      return "https://www.instagram.com/" + kind + "/" + m[2] + "/embed/";
    }
    var io = "IntersectionObserver" in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        mount(e.target);
      });
    }, { rootMargin: "300px" }) : null;
    function mount(tile) {
      var src = tile.getAttribute("data-sc-ig-src");
      var ph = tile.querySelector(".sc-social__ph");
      if (!src || !ph) return;
      var wrap = document.createElement("span");
      wrap.className = "sc-social__ig";
      wrap.innerHTML = '<iframe src="' + src + '" loading="lazy" scrolling="no" tabindex="-1" title="Instagram post"></iframe>';
      ph.replaceWith(wrap);
    }
    function openPost(url, src) {
      var ov = document.createElement("div");
      ov.className = "sc-tiktok-ov sc-tiktok-ov--ig";
      ov.innerHTML =
        '<div class="sc-tiktok-ov__box">' +
        '<button type="button" class="sc-tiktok-ov__close" aria-label="Close">×</button>' +
        '<iframe src="' + src + 'captioned/" allowfullscreen title="Instagram post"></iframe>' +
        '<a class="sc-tiktok-ov__link" href="' + url + '" target="_blank" rel="noopener">view on Instagram ↗︎</a>' +
        "</div>";
      function close() {
        document.removeEventListener("keydown", onKey);
        document.body.style.overflow = "";
        ov.remove();
      }
      function onKey(e) { if (e.key === "Escape") close(); }
      ov.addEventListener("click", function (e) {
        if (e.target === ov || e.target.classList.contains("sc-tiktok-ov__close")) close();
      });
      document.addEventListener("keydown", onKey);
      document.body.style.overflow = "hidden";
      document.body.appendChild(ov);
    }
    tiles.forEach(function (tile) {
      var url = tile.getAttribute("data-sc-instagram");
      tile.removeAttribute("data-sc-instagram");
      var src = embedUrl(url);
      if (!src) return;
      tile.setAttribute("data-sc-ig-src", src);
      // Play badge only for video posts (reels / IGTV) — photo posts just open on click
      if (/\/(reel|tv)\//.test(src)) tile.classList.add("sc-social__tile--playable");
      tile.addEventListener("click", function (e) {
        e.preventDefault();
        openPost(url, src);
      });
      if (tile.querySelector(".sc-social__ph")) {
        if (io) io.observe(tile); else mount(tile);
      }
    });
  }

  // SHOP category mega menu — hovering (or focusing) a category in the left rail
  // swaps the product grid on the right.
  function initMegaMenu() {
    document.querySelectorAll(".sc-mega").forEach(function (menu) {
      var panesBox = menu.querySelector(".sc-mega__panes");
      var mq = window.matchMedia("(max-width: 900px)");
      function activate(i) {
        menu.querySelectorAll("[data-sc-mega-cat]").forEach(function (el) {
          el.classList.toggle("is-active", el.getAttribute("data-sc-mega-cat") === i);
        });
        menu.querySelectorAll("[data-sc-mega-pane]").forEach(function (el) {
          el.classList.toggle("is-active", el.getAttribute("data-sc-mega-pane") === i);
        });
      }
      // Mobile: drop each category's pane directly beneath its rail item (accordion).
      // Desktop: keep panes in the right-hand column beside the rail.
      function layout() {
        var mobile = mq.matches;
        menu.querySelectorAll("[data-sc-mega-cat]").forEach(function (cat) {
          var pane = menu.querySelector('[data-sc-mega-pane="' + cat.getAttribute("data-sc-mega-cat") + '"]');
          if (!pane) return;
          if (mobile) {
            if (cat.nextElementSibling !== pane) cat.after(pane);
          } else if (panesBox && pane.parentNode !== panesBox) {
            panesBox.appendChild(pane);
          }
        });
      }
      layout();
      if (mq.addEventListener) mq.addEventListener("change", layout);
      menu.querySelectorAll("[data-sc-mega-cat]").forEach(function (cat) {
        var idx = cat.getAttribute("data-sc-mega-cat");
        cat.addEventListener("mouseenter", function () { activate(idx); });
        cat.addEventListener("focus", function () { activate(idx); });
        // Touch/mobile: tapping a category reveals its cards beneath it instead
        // of navigating (there's no hover). Cards are the links to products.
        cat.addEventListener("click", function (e) {
          if (mq.matches) {
            e.preventDefault();
            activate(idx);
          }
        });
      });
    });
  }

  // Obfuscated email links — the address is split into data-u/data-d in the HTML
  // so scrapers reading the source don't find it; assembled here for humans.
  function initMailLinks() {
    document.querySelectorAll("[data-sc-mail]").forEach(function (a) {
      var addr = a.getAttribute("data-u") + "@" + a.getAttribute("data-d");
      var subject = a.getAttribute("data-subject");
      a.href = "mailto:" + addr + (subject ? "?subject=" + encodeURIComponent(subject) : "");
      a.textContent = addr;
      a.removeAttribute("data-sc-mail");
    });
  }

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  /* ---------- guarantee steps — scroll reveal + line draw ---------- */
  function initGuaranteeSteps() {
    var lists = document.querySelectorAll("[data-sc-gsteps]");
    if (!lists.length || !("IntersectionObserver" in window)) return; // no JS/old browser: stays visible
    lists.forEach(function (list) {
      if (list.__scArmed) return;
      list.__scArmed = true;
      list.classList.add("is-armed");
      // draw the connecting line once the list scrolls into view
      var lineIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { list.classList.add("is-in"); lineIO.disconnect(); } });
      }, { threshold: 0.12 });
      lineIO.observe(list);
      // reveal each step as it enters
      var stepIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add("is-in"); stepIO.unobserve(e.target); }
        });
      }, { rootMargin: "0px 0px -12% 0px", threshold: 0.25 });
      list.querySelectorAll(".sc-gstep").forEach(function (s) { stepIO.observe(s); });
    });
  }

  /* ---------- gift card (denomination + recipient toggle) ---------- */
  function initGiftCard() {
    document.querySelectorAll("[data-sc-gc-form]").forEach(function (form) {
      if (form.__scGcBound) return;
      form.__scGcBound = true;
      var scope = form.closest(".sc-gc") || form;
      var amountEls = scope.querySelectorAll("[data-gc-amount]");
      var fields = form.querySelector("[data-sc-gc-fields]");
      var toggle = form.querySelector("[data-sc-gc-toggle]");

      // update the card visual + CTA to the chosen amount
      form.querySelectorAll('input[name="id"]').forEach(function (radio) {
        radio.addEventListener("change", function () {
          var a = radio.getAttribute("data-amount");
          if (a) amountEls.forEach(function (el) { el.textContent = a; });
        });
      });

      // show/hide recipient fields
      if (toggle && fields) {
        var sync = function () {
          fields.hidden = !toggle.checked;
          fields.querySelectorAll("input, textarea").forEach(function (el) { el.disabled = !toggle.checked; });
        };
        toggle.addEventListener("change", sync);
        sync();
      }
    });
  }

  ready(function () {
    initVideos();
    initAccordions();
    initLoginToggle();
    initGallery();
    initProductForm();
    initCart();
    initCardInfo();
    initStripsCarousel();
    initCollageCarousel();
    initMenu();
    initStickyHeader();
    initStatCounters();
    initSocialEmbeds(); initInstagramTiles(); initSocialArrows();
    initMailLinks();
    initMegaMenu();
    initPeel();
    initGuaranteeSteps();
    initGiftCard();
    initCartDrawer();
    initImageFade();
    refreshCartCount();
  });

  // Re-init when sections are re-rendered in the theme editor.
  document.addEventListener("shopify:section:load", function () {
    initVideos(); initAccordions(); initLoginToggle(); initGallery(); initProductForm(); initCart(); initStripsCarousel(); initCollageCarousel(); initMenu(); initStickyHeader(); initStatCounters(); initSocialEmbeds(); initInstagramTiles(); initSocialArrows(); initMailLinks(); initMegaMenu(); initPeel(); initGuaranteeSteps(); initGiftCard(); initCartDrawer();
  });
})();
